export default __webpack_public_path__ + "8f677f9fd0e2ff418188babc49dbb77b.png";